import { flowRight as compose } from 'lodash';

/**
 * Composable function to extract the tacking term
 * @param {ISearch} data - api search response
 * @param {string} query - query string
 * @returns {ISearchTrackingData}
 */
const getTrackingData = (data, query) => {
    return {
        siteSearchQuery: query, // nach was gesucht wurde. bei autosuggestion ist dies das angeklickte query aus der Liste
        siteSearchTypedQuery: query, // eingetippte Suchphrase
        ...data,
    };
};

/**
 * Composed function to track only the categories search items
 */
export const getCategoriesTrackingData = compose(({ siteSearchQuery, siteSearchTypedQuery, categories }) => {
    return {
        searchType: 'kategorie-search', // Typ der Suche (produkt-search, kategorie-search, etc.)
        suggestSearch: 'false', // Wenn Suggest-Search verwendet wird, bitte auf true, sonst auf false setzen
        siteSearchQuery,
        siteSearchTypedQuery,
        siteSearchResultsTotalAmount: categories.total_hits, // Gesamtanzahl von Suchtreffer
        siteSearchResults: categories.items.reduce((acc, item) => {
            acc[item.id] = 1;
            return acc;
        }, {}), // Die im Array stehende Produktkategorien sollen dynamisch erweitert werden, einsprachig auf Deutsch
    };
}, getTrackingData);

/**
 * Composed function to track only the products search items
 */
export const getProductsTrackingData = compose(({ siteSearchQuery, siteSearchTypedQuery, products }) => {
    return {
        searchType: 'produkt-search', // Typ der Suche (produkt-search, kategorie-search, etc.)
        suggestSearch: 'false', // Wenn Suggest-Search verwendet wird, bitte auf true, sonst auf false setzen
        siteSearchQuery,
        siteSearchTypedQuery,
        siteSearchResultsTotalAmount: products.total_hits, // Gesamtanzahl von Suchtreffer
        siteSearchResults: products.items.reduce((acc, item) => {
            if (acc[item.tracking_category]) {
                ++acc[item.tracking_category];
            } else {
                acc[item.tracking_category] = 1;
            }
            return acc;
        }, {}), // Die im Array stehende Produktkategorien sollen dynamisch erweitert werden, einsprachig auf Deutsch
    };
}, getTrackingData);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/search/helpers.js